import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import cs from './cs/common.json';
import csAnalyses from './cs/analyses.json';
import csFindings from './cs/findings.json';
import csProjects from './cs/projects.json';
import csReports from './cs/reports.json';
import csRuns from './cs/runs.json';
import csOps from './cs/ops.json';
import csMissions from './cs/missions.json';
import csBoundary from './cs/boundary.json';
import csViewer from './cs/viewer.json';
import en from './en/common.json';
import enAnalyses from './en/analyses.json';
import enFindings from './en/findings.json';
import enProjects from './en/projects.json';
import enReports from './en/reports.json';
import enRuns from './en/runs.json';
import enOps from './en/ops.json';
import enMissions from './en/missions.json';
import enBoundary from './en/boundary.json';
import enViewer from './en/viewer.json';

export const LOCALES = ['cs', 'en'] as const;
export type Locale = (typeof LOCALES)[number];

/** Language autonyms for locale pickers; language names are conventionally left untranslated. */
export const LOCALE_LABELS: Record<Locale, string> = { cs: 'Čeština', en: 'English' };

i18n.use(initReactI18next).init({
  resources: {
    cs: { common: cs, projects: csProjects, runs: csRuns, findings: csFindings, analyses: csAnalyses, viewer: csViewer, reports: csReports, ops: csOps, missions: csMissions, boundary: csBoundary },
    en: { common: en, projects: enProjects, runs: enRuns, findings: enFindings, analyses: enAnalyses, viewer: enViewer, reports: enReports, ops: enOps, missions: enMissions, boundary: enBoundary },
  },
  lng: (localStorage.getItem('locale') as Locale) || 'cs',
  fallbackLng: false,
  defaultNS: 'common',
  ns: ['common', 'projects', 'runs', 'findings', 'analyses', 'viewer', 'reports', 'ops', 'missions', 'boundary'],
  interpolation: { escapeValue: false },
});

/** `{{files, brief}}`: a list of names cut to its first three, the rest counted ("a.laz, b.laz, c.laz a 5 dalších"). */
const BRIEF_SHOWN = 3;
i18n.services.formatter?.add('brief', (value: unknown, lng: string | undefined) => {
  if (!Array.isArray(value)) return String(value ?? '');
  const items = value.slice(0, BRIEF_SHOWN).map(String);
  const rest = value.length - items.length;
  if (rest > 0) items.push(i18n.t('more', { ns: 'findings', lng, count: rest }));
  return new Intl.ListFormat(lng, { type: 'conjunction' }).format(items);
});

export function setLocale(l: Locale) {
  localStorage.setItem('locale', l);
  void i18n.changeLanguage(l);
  document.documentElement.lang = l;
}

export default i18n;
